export const NEW_BUFFER_SEGMENT = "new_buffer_segment";
export const CLEAR_BUFFER_SEGMENTS = "clear_buffer_segments";
export const CLEAR_BUFFER_SEGMENT = "clear_buffer_segment";